<template>
  <div class="inputGai">
    <RxkInput
      style="width: 100%"
      :modal-value="innerValue[0]"
      :disabled="renderConfig.disabled"
      :maxlength="renderConfig.maxlength"
      @change="val => handleChange(val, 1)"
      @input="handleInput1"
    />
    <span class="separate">-</span>
    <RxkInput
      style="width: 100%"
      :disabled="renderConfig.disabled"
      :modal-value="innerValue[1]"
      :maxlength="renderConfig.maxlength"
      @change="val => handleChange(val, 2)"
      @input="handleInput2"
    />
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkInput } from '@/components/common/RxkInput'
import { isNullOrUndefOrEmpty } from '@/utils/is'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue'])

const innerValue = computed({
  get() {
    return props.modelValue || ['', '']
  },
  set(newVal) {
    // 监听不到数组的变化
    emit('update:modelValue', newVal)
  }
})
function handleChange(val: any, sign: number) {
  if (sign === 1 && val === '') innerValue.value[0] = ''
  if (sign === 2 && val === '') innerValue.value[1] = ''
  if (
    innerValue.value?.[0] !== 0 &&
    innerValue.value?.[1] !== 0 &&
    !innerValue.value?.[0] &&
    !innerValue.value?.[1]
  ) {
    innerValue.value = []
  }
  emit('update:modelValue', innerValue.value)
}
function handleInput1(val: any) {
  let temp = val.replace(/[^\d]/g, '')
  console.log(temp, 'temp22')
  innerValue.value[0] = !isNullOrUndefOrEmpty(temp) ? Number(temp) : ''
}
function handleInput2(val: any) {
  let temp = val.replace(/[^\d]/g, '')
  innerValue.value[1] = !isNullOrUndefOrEmpty(temp) ? Number(temp) : ''
}
</script>
<style lang="scss" scoped>
.inputGai {
  display: flex;
  align-items: center;
  .separate {
    padding: 0 4px;
    color: #999;
  }
}
</style>
